<template>
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <div v-if="getLanguageChanged">{{refresh()}}</div>
        
        <v-card v-if="$store.getters.getLanguageList">     
            <div v-if="getShowHelpEvent">{{showHelp()}}</div>
            <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
            <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>
            <div v-if="needInit">{{initData()}}</div> 

            <v-toolbar dense @click="showAssignment = !showAssignment" color="blue lighteen-5">
            <v-app-bar-nav-icon></v-app-bar-nav-icon>
                    <v-toolbar-title>Assignment</v-toolbar-title>
            </v-toolbar>
            <v-card outlined>
                <div v-if="showAssignment" v-html="mycontent.assignment" style="margin:5px"></div>
            </v-card>
            
            <v-card>  
                    <v-toolbar dense color="blue lighten-5">
                            <v-spacer></v-spacer>
                            <v-btn outlined style="margin-right:50px;">{{grade}}%</v-btn>
                            <v-icon @click="showCompileInfo = !showCompileInfo" :color="getCompilerColor()" style="margin:5px;">build</v-icon>
                            <v-icon @click="showExecuteInfo = !showExecuteInfo" :color="getResultColor()" large style="magrin-right:10px;">reorder</v-icon>
                            <v-icon @click="runCode()" color="green" large style="magrin-right:5px;">check_circle_outline</v-icon>
                    </v-toolbar>     
                        <div>
                            <v-tabs
                                center-active 
                                color="blue" slider-color="blue"
                                class="customTabTitle"
                                >
                                <v-tab v-for="(filename, index) in files.files" :key="index" @click="setActiveContent(index)">                                    
                                    {{filename}} &nbsp;
                                </v-tab>
                            </v-tabs>

                            <v-card v-if="vplProcessInfo>''" color="lime lighten-5">
                                <v-card-text>
                                    {{vplProcessInfo}}
                                </v-card-text>     
                            </v-card>
                            <v-card v-if="showCompileInfo" color="lime lighten-4">
                                <v-card-text>
                                    <span v-html="vplCompilerInfo"></span>
                                </v-card-text>     
                            </v-card>
                            <v-card v-if="showExecuteInfo" color="lime lighten-5">
                                <v-card-text>
                                    <span v-html="vplExecutionInfo"></span>
                                </v-card-text>     
                            </v-card>

                            <codemirror class="border-top" ref="myCm" v-model="mycontent.files[activeIndexFiles_files].rContent" 
                                            :options="cmOptions"
                                            >
                            </codemirror>
                            <v-card v-if="showMyAnswer">
                                <v-toolbar dense color="blue lighten-5">                        
                                    <v-toolbar-title>Authors solution:</v-toolbar-title>
                                    
                                    <v-spacer></v-spacer>
                                </v-toolbar>

                                <codemirror class="border-top" ref="myCm" v-model="mycontent.files[activeIndexFiles_files].aContent" 
                                                :options="cmOptions"
                                                >
                                </codemirror>
                            </v-card>
                        </div>
            </v-card>

        </v-card>

        <v-card v-if="showMyHelp">
            <div v-html="mycontent.help">
            </div>
            <v-btn @click="showMyHelp = false">Hide Help</v-btn>
        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
// import { closeSync } from 'fs'
import { codemirror } from 'vue-codemirror'
import configData from '../../config.js'
import axios from './../../axios-auth'


export default {   
    data() {
        return {
                showAssignment: true,
                showCompileInfo: false,
                showExecuteInfo: false,
                vplProcessInfo: '',
                vplCompilerInfo: '',
                vplExecutionInfo: '',
                grade: 0,
                isRunning: false,
                activeIndexFiles_files : 0, // content for active tab in files
                mycontent:  {
                    title: 'loading...',
                    assignment: 'loading...',
                    files: [{
                                rContent: '',
                                aContent : ''
                            }
                    ],                     
                    testCases: '',
                    filesToKeep: [ ],
                    configFiles: [ ],
                    help: ''                    
                },
                files: {
                    files: ['loading...'],
                    filesToKeep: [],
                    configFiles: []
                },
                cmOptions: {
                    tabSize: 4,
                    styleActiveLine: true,
                    lineNumbers: true,
                    line: true,
                    mode: 'text/javascript',
                    lineWrapping: true,
                    extraKeys: {'Ctrl-Space': 'autocomplete',
                            'F11'(cm) {
                                cm.setOption("fullScreen", !cm.getOption("fullScreen"))
                            },
                            'Esc'(cm) {
                            if (cm.getOption("fullScreen")) cm.setOption("fullScreen", false)
                        }
                    }
                },
                feedback: null,
                showMyHelp: false,
                needInit : false,
                showMyAnswer: false
        }
    },
    components :{
        codemirror
    },

    computed: 
        mapGetters([
                    'getShowHelpEvent',
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getLanguageList',
                    'getLanguagePrimary',
                    'getLanguageChanged'
                    ])
    ,    
    props: { 
        dcontent: Object
    },
    methods: {
        sendContent() {

        },
        initData() {            
            this.needInit = false         
            this.$store.commit('setFeedback', null)   
            this.mycontent = JSON.parse(this.dcontent.data.content)            
            this.files = JSON.parse(this.dcontent.data.globals).files

//            console.log(this.mycontent)
//            console.log(this.files)

        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent', false)
            this.runCode()
            // compare with myResult
        },
        showAnswer() { 
            this.$store.commit('setShowAnswerEvent', false)
            this.showMyAnswer = true
        },
        showHelp() {
            this.$store.commit('setShowHelpEvent', false)
            this.showMyHelp = true
        },
        refresh() {
            this.$store.commit('setLanguageChanged',false)
            this.initData()
        },
        getResultColor() {
            if (this.grade == 0 && this.vplExecutionInfo == '') return 'primary'
            if (this.grade == 0) return 'red'
            if (this.grade == 100) return 'green'
            return 'orange'
        },
        getCompilerColor() {
            if (this.vplCompilerInfo.lenght > 11) return 'red'
            if (this.vplCompilerInfo == '' && this.vplExecutionInfo == '') return 'primary'
            return 'green'
        },
        setActiveContent(index) {
            this.activeIndexFiles_files = index
        },
        runCode() {
            if (this.isRunning) return
            this.vplProcessInfo = ''  
            this.vplCompilerInfo = ''  
            this.vplExecutionInfo = ''  
            var submitted_files = []
            var keep_files = []
            var config_files = []

            for (let i=0; i<this.files.files.length; i++) {
                submitted_files.push( {
                    filename: this.files.files[i],
                    filecontent: this.mycontent.files[i].rContent
                })
            }

            for (let i=0; i<this.files.filesToKeep.length; i++) {
                keep_files.push( {
                    filename: this.files.filesToKeep[i],
                    filecontent: this.mycontent.filesToKeep[i]
                })
            }
            for (let i=0; i<this.files.configFiles.length; i++) {
                config_files.push( {
                    filename: this.files.configFiles[i],
                    filecontent: this.mycontent.configFiles[i]
                })
            }

            let data = {
                course_id: JSON.parse(localStorage.getItem('position')).activeCourse.id,
                submitted_files: JSON.stringify(submitted_files),
                keep_files: JSON.stringify(keep_files),
                config_files: JSON.stringify(config_files),
                testCases: this.mycontent.testCases
            }

//            console.log(data)
            axios.post('/vpl-run-test', data, this.$store.getters.getAxiosConfig )
            .then((res) => {
                // set data to var
                this.readVPLAnswer(res.data);
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        },
        readVPLAnswer(tickets) {
            this.showCompileInfo = false
            this.showExecuteInfo = false
            let monitoringTarger = configData.jailSocketConnection + tickets.monitorticket+'/monitor';

            this.vplProcessInfo = 'awaiting connection... '
            this.monitoringSocket = new WebSocket(monitoringTarger);
            
            this.monitoringSocket.onopen = () => {
                    this.vplProcessInfo = "connected... ";                   
                this.monitoringSocket.onerror = ({data}) => { this.vplProcessInfo = data ; };                    
                this.monitoringSocket.onmessage = ({data}) => {
                    if (data.substring(data.length - 3) == 'seg') data = data.substring(0, data.length - 2) + '.'
                    this.vplProcessInfo = data ;

                    if (data == 'retrieve:') { // compilation successfull, start running
                            let d = { adminticket: tickets.adminticket }
                            this.vplProcessInfo = 'reading result'
                            axios.post('/vpl-get-result', d, this.$store.getters.getAxiosConfig )
                            .then((res) => {
                                // set data to var
                                this.vplCompilerInfo = '<pre>' + res.data.compilation + '</pre>'
                                this.vplExecutionInfo = '<pre>' + res.data.execution + '</pre>'
                                this.vplProcessInfo = ''
                                if (res.data.compilation >'') this.showCompileInfo = true
                                else this.showExecuteInfo = true
                                let pos = res.data.execution.indexOf('Grade :=>>')
                                if (pos>0) this.grade = res.data.execution.substring(pos+10).trim()
                                if (this.grade == '100') this.showExecuteInfo = false
                            })
                            .catch(error => {
                                this.vplProcessInfo = 'error ' + error
                                this.$store.commit('setFeedback', error)
                            })
                    }
                    if (data == 'close:') { 
                        this.isRunning = false 
                        this.vplProcessInfo = ''
                    }
                }
            }
        }

    },
    mounted() {
        this.needInit = true
    },
    
}
</script>

<style>

</style>